"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const touchableElement_1 = __importDefault(require("../pressables/touchableElement"));
const text_1 = __importStar(require("../text/text"));
const PrimaryButton = ({ disabled = false, title, onPress, color = colors_1.default.COLOR_PRIMARY, disabledSpecialColor = colors_1.default.COLOR_GRAY_LIGHT, textColor = colors_1.default.COLOR_WHITE, disabledSpecialTextColor = colors_1.default.COLOR_GRAY_DARK, eventName, }) => (react_1.default.createElement(touchableElement_1.default, { onPress: onPress, eventName: eventName, style: [
        {
            borderRadius: 8,
        },
        {
            backgroundColor: disabled ? disabledSpecialColor : color,
        },
        styles_1.default.minimumMarginBetweenElementsVertically,
        styles_1.default.centerChildHorizontalVertical,
        styles_1.default.flexOne,
    ], disabled: disabled },
    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: { margin: 15 }, color: disabled ? disabledSpecialTextColor : textColor }, title)));
PrimaryButton.defaultProps = {
    disabled: false,
    color: colors_1.default.COLOR_PRIMARY,
    textColor: colors_1.default.COLOR_WHITE,
};
exports.default = PrimaryButton;
